<template>
    <div class="card card-custom" v-loading="loading">
        <div class="card-header">
            <h3 class="card-title align-items-start flex-column py-3">
                <div class="d-flex align-items-center">
                    <span class="card-label font-weight-bolder text-dark" v-text="title"></span>
                    <span v-if="formQ.length!=0 && formQ.mstatus==1" class="svg-icon svg-icon-1 svg-icon-success"><svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24">
                            <path d="M10.0813 3.7242C10.8849 2.16438 13.1151 2.16438 13.9187 3.7242V3.7242C14.4016 4.66147 15.4909 5.1127 16.4951 4.79139V4.79139C18.1663 4.25668 19.7433 5.83365 19.2086 7.50485V7.50485C18.8873 8.50905 19.3385 9.59842 20.2758 10.0813V10.0813C21.8356 10.8849 21.8356 13.1151 20.2758 13.9187V13.9187C19.3385 14.4016 18.8873 15.491 19.2086 16.4951V16.4951C19.7433 18.1663 18.1663 19.7433 16.4951 19.2086V19.2086C15.491 18.8873 14.4016 19.3385 13.9187 20.2758V20.2758C13.1151 21.8356 10.8849 21.8356 10.0813 20.2758V20.2758C9.59842 19.3385 8.50905 18.8873 7.50485 19.2086V19.2086C5.83365 19.7433 4.25668 18.1663 4.79139 16.4951V16.4951C5.1127 15.491 4.66147 14.4016 3.7242 13.9187V13.9187C2.16438 13.1151 2.16438 10.8849 3.7242 10.0813V10.0813C4.66147 9.59842 5.1127 8.50905 4.79139 7.50485V7.50485C4.25668 5.83365 5.83365 4.25668 7.50485 4.79139V4.79139C8.50905 5.1127 9.59842 4.66147 10.0813 3.7242V3.7242Z" fill="#00A300"></path>
                            <path class="permanent" d="M14.8563 9.1903C15.0606 8.94984 15.3771 8.9385 15.6175 9.14289C15.858 9.34728 15.8229 9.66433 15.6185 9.9048L11.863 14.6558C11.6554 14.9001 11.2876 14.9258 11.048 14.7128L8.47656 12.4271C8.24068 12.2174 8.21944 11.8563 8.42911 11.6204C8.63877 11.3845 8.99996 11.3633 9.23583 11.5729L11.3706 13.4705L14.8563 9.1903Z" fill="white"></path>
                        </svg>
                    </span>
                    <div v-if="formQ.length!=0" :class="'btn btn-sm btn-light-'+formQ.param1+' ml-2 py-1 px-3'" ariadescribedby="el-popper-3403">{{formQ.nstatus}}</div>
                </div>
                <span class="text-muted font-weight-bold font-size-sm">Confirme su participando completando este formulario</span>
            </h3>
        </div>
        <div class="card-body">
            <div class="row p-5 mb-10 border border-secondary rounded border-dashed bg-gray-100">
                <div class="col-sm-4">
                    <div class="font-weight-bold text-muted mb-1">Estado del formulario:</div>
                    <div class="font-weight-bolder font-size-6" v-html="statusNameForm()"></div>
                </div>
                <!--statusNameForm()-->
                <div class="col-sm-4">
                    <div class="font-weight-bold text-muted mb-1">Fecha de creación:</div>
                    <div class="font-weight-bolder text-gray-800 d-flex align-items-center flex-wrap">
                        <span class="text-capitalize">{{$moment(fconfig.date_start).format("DD MMM YYYY")}}</span>
                    </div>
                </div>
                <div class="col-sm-4">
                    <div class="font-weight-bold text-muted mb-1">Fecha de cierre:</div>
                    <div class="font-weight-bolder text-gray-800 d-flex align-items-center flex-wrap">
                        <span class="text-capitalize pr-2">{{$moment(fconfig.date_end).format("DD MMM YYYY")}}</span>
                        <span class="text-danger d-flex align-items-center">
                            <!--<span class="bullet bullet-dot bg-danger mr-2"></span>Finaliza en 7 días--></span>
                    </div>
                </div>
            </div>
            <el-form ref="formQ" :model="formQ" label-position="left">
                <div class="row mx-auto mb-6">
                    <div class="col-sm-2 border bg-primary-o-20 d-flex align-items-center">
                        Institucion
                    </div>
                    <div class="col-sm-5 border">
                        <el-form-item prop="institution" class="my-2">
                            <el-select v-model="formQ.institution" size="small" placeholder="Pais/Región" class="w-100">
                                <el-option :value="formQ.institution" :label="formQ.business"></el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                    <div class="col-sm-1 border bg-primary-o-20 d-flex align-items-center">
                        País
                    </div>
                    <div class="col-sm-4 border">
                        <el-form-item prop="country" class="my-2">
                            <el-select v-model="formQ.country" size="small" placeholder="Pais/Región" class="w-100">
                                <el-option :value="formQ.country" :label="formQ.country_name"></el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                </div>

                <div class="row">
                    <div class="col-sm-8 offset-2">
                        <table class="table table-bordered">
                            <colgroup>
                                <col class="col-md-6">
                                <col class="col-md-3">
                                <col class="col-md-3">
                            </colgroup>
                            <tr class="bg-gray-100 text-center">
                                <th scope="col" class="align-middle">Atletas</th>
                                <th scope="col">Men<br>Hombres</th>
                                <th scope="col">Women<br>Mujeres</th>
                            </tr>
                            <tbody>
                                <tr v-for="(domain, index) in formQ.athletes" :key="index">
                                    <td class="font-weight-bolder align-middle">{{domain.name}}</td>
                                    <td>
                                        <div v-if="formQ.mstatus == '1' || formQ.mstatus == '3'" class="border rounded py-2 px-4" v-text="domain.men"></div>
                                        <el-form-item v-else
                                            class="mb-0"
                                            :key="domain.key"
                                            :prop="'athletes.' + index + '.men'"
                                            :rules="{required: true, message: 'Requerido', trigger: ['blur', 'change']}"
                                            size="small">
                                            <el-input v-model="domain.men"  class="text-center" @keypress="isNumber($event)" maxlength="2"></el-input>
                                        </el-form-item>
                                    </td>
                                    <td>
                                        <div v-if="formQ.mstatus == '1' || formQ.mstatus == '3'" class="border rounded py-2 px-4" v-text="domain.women"></div>
                                        <el-form-item v-else
                                            class="mb-0"
                                            :key="domain.key"
                                            :prop="'athletes.' + index + '.women'"
                                            :rules="{required: true, message: 'Requerido', trigger: ['blur', 'change']}"
                                            size="small">
                                            <el-input v-model="domain.women" class="text-center" @keypress="isNumber($event)" maxlength="2"></el-input>
                                        </el-form-item>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="font-weight-bolder">Total</td>
                                    <td class="font-weight-bolder text-center">{{getMen}}</td>
                                    <td class="font-weight-bolder text-center">{{getWomen}}</td>
                                </tr>

                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-8 offset-2">
                        <table class="table table-bordered">
                            <colgroup>
                                <col class="col-md-6">
                                <col class="col-md-2">
                                <col class="col-md-2">
                                <col class="col-md-2">
                            </colgroup>
                            <tr class="bg-gray-100 text-center">
                                <th scope="col" class="align-middle">Function / Función</th>
                                <th scope="col">Men<br>Hombres</th>
                                <th scope="col">Women<br>Mujeres</th>
                                <th scope="col">Total</th>
                            </tr>
                            <tbody>
                                <tr>
                                    <td class="font-weight-bolder align-middle">Athletes  / Atletas</td>
                                    <td><div class="border rounded py-2 px-4">{{getMen}}</div></td>
                                    <td><div class="border rounded py-2 px-4">{{getWomen}}</div></td>
                                    <td><div class="border rounded py-2 px-4">{{getMen + getWomen}}</div></td>
                                </tr>
                                <tr v-for="(item, index) in formQ.functions" :key="index">
                                    <td class="font-weight-bolder align-middle">{{item.name}} 
                                        <el-tooltip placement="top" v-if="item.value == 'OT'">
                                            <template #content> Include coaches<br />Incluir entrenadores</template>
                                            <i  class="fa fa-info-circle"></i>
                                        </el-tooltip>
                                        </td>
                                    <td>
                                        <div v-if="formQ.mstatus == '1' || formQ.mstatus == '3'" class="border rounded py-2 px-4" v-text="item.men"></div>
                                        <el-form-item v-else 
                                            class="mb-0"
                                            :key="item.key"
                                            :prop="'functions.' + index + '.men'"
                                            :rules="{required: true, message: 'Requerido', trigger: 'blur'}"
                                            size="small">
                                            <el-input v-model="item.men"  class="text-center" @keypress="isNumber($event)" maxlength="2"></el-input>
                                        </el-form-item>
                                    </td>
                                    <td>
                                        <div v-if="formQ.mstatus == '1' || formQ.mstatus == '3'" class="border rounded py-2 px-4" v-text="item.women"></div>
                                        <el-form-item v-else 
                                            class="mb-0"
                                            :key="item.key"
                                            :prop="'functions.' + index + '.women'"
                                            :rules="{required: true, message: 'Requerido', trigger: 'blur'}"
                                            size="small">
                                            <el-input v-model="item.women" class="text-center" @keypress="isNumber($event)" maxlength="2"></el-input>
                                        </el-form-item>
                                    </td>
                                    <td><div class="border rounded py-2 px-4">{{getprueba(item.value)}}</div></td>
                                </tr>
                            </tbody>
                        </table>

                    </div>
                </div>
                <div v-if="finaliza">
                    <hr>
                    <div v-if="formQ.length==0 || formQ.mstatus==0" class="btn btn-secondary mr-3" @click="saveAsDraf">Guardar como borrador</div>
                    <div v-if="formQ.length==0 || formQ.mstatus==0 || formQ.mstatus==2" class="btn btn-primary" @click="saveAndSend('formQ')">Guardar y enviar</div>
                </div>
            </el-form>

        </div>
    </div>
</template>
<script>

//services
import acrService from '@/core/services/acr.service';

export default {
    name: 'Quantitative',
    props: {
        title: {
            type: String,
            required: true,
            default: null
        },
        idevent: {
            type: String,
            required: true,
            default: null
        }
    },
    data: () => ({
        loading: false,
        fconfig: {},
        details: [],
        formQ: {
            save: 0,
            idevent: null,
            institution: null,
            business: null,
            country: null,
            country_name: null,
            athletes: [],
            functions: []
        },
        finaliza: true,
    }),
    computed: {
        getMen: function() {
            let suma = 0;
            this.formQ.athletes.filter((item) => { suma += parseInt(item.men) })
            return suma
        },
        getWomen: function() {
            let suma = 0;
            this.formQ.athletes.filter((item) => { suma += parseInt(item.women) })
            return suma
        },
        

    },
    methods: {
        isNumber(evt) {
            if (!/^[0-9]+$/.test(evt.key) || evt.key === '.') return evt.preventDefault();
        },
        getprueba(text) {
            let suma = 0;
            this.formQ.functions.filter((item) => { 
                if(item.value === text)
                    suma = parseInt(item.men) + parseInt(item.women)
             })
             return suma
        },
        statusNameForm() {
            try {
                if (Object.keys(this.fconfig).length === 0)
                    return 'Información no disponible.';

                if (this.fconfig.mstatus == 'O') {
                    if (this.$moment(this.fconfig.date_end).diff(this.$moment()) > 0) {
                        this.finaliza = true;
                        return '<span class="text-primary">' + this.fconfig.nstatus + '</span>';
                    } else
                        return '<span class="text-danger">Cerrado para inscripción</span>'
                } else
                    return this.fconfig.nstatus;

            } catch (error) {
                return '<span class="text-warning">Información no disponible.</span>';
            }
        },
        async get_data() {
            this.loading = true
            await acrService.getFeQ(this.idevent).then((response) => {
                this.loading = false
                this.fconfig = response.data.config
                this.formQ   = response.data.formQ
            }).catch((error) => {   
                this.loading = false
            }).finally( ()=> {
                this.loading = false
            })

        },
        async save(method) {
            this.loading = true
            this.formQ.save = method
            await acrService.saveFeQ(this.formQ).then( (response) => {
                if(response.status == 200 || response.status == 201) {
                    this.$notify.success({
                        title: 'Perfecto',
                        message: response.data.mesage,
                        dangerouslyUseHTMLString: true
                    });
                    this.get_data();
                } else {
                    this.$notify.danger({
                        title: 'Lo sentimos',
                        message: 'No se pudo procesar la información',
                        dangerouslyUseHTMLString: true
                    });
                }
            }).catch( (error) => {
                this.loading = false
            }).finally( ()=> {
                this.loading = false
            })
        },
        saveAsDraf() {
            this.save(0);
        },
        saveAndSend(formName) {
            this.$refs[formName].validate(async (valid) => {
                if (!valid)
                    return false

                this.save(1);
            });
        }

    },
    created() {
        this.get_data()
    }
}
</script>